(function(){

  'use strict';

  function pxDriverWarningDialog() {
    return {
      restrict: 'EA',
      scope: {
        warningData: '=warningData',
      },
      templateUrl: 'app/directives/driverWarningDialog/driver-warning-dialog.template.html',
      link: function(scope) {
        
        scope.data = scope.warningData;     

      }
    };
  }

  pxDriverWarningDialog.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxDriverWarningDialog', pxDriverWarningDialog);

})();
